import { Component, Inject, Input, OnInit } from '@angular/core';
import { LoggingService } from '../../../shared/services/logging/logging.service';
import { Process } from '../store/process.model';

@Component({
    selector: 'ef-process-detail',
    templateUrl: './process-detail.component.html',
    styleUrls: ['./process-detail.component.scss'],
    standalone: false
})
export class ProcessDetailComponent implements OnInit {
    @Input() public process: Process;
    constructor(@Inject(LoggingService) private log: LoggingService) {}

    ngOnInit() {
        this.log.debug({
            type: 'ProcessDetailComponent:ngOnInit',
            process: this.process
        });
    }
}
